import { user } from 'src/StateObserver';
import { MapDef } from '../game/defs/map';
import { isSuperLollipopActive } from 'src/replicant/superLollipop/superLollipop.getters';
import { moveReductionValues } from './movereduction.ruleset';

/**
 * Check if move reduction should be applied.
 * Move reduction is applied if:
 * 1. The user has a super lollipop active.
 * @returns
 */
export function shouldApplyMoveReduction() {
  const state = user();

  return isSuperLollipopActive(state);
}

/**
 * Get puzzle moves applying move reduction if necessary.
 * @param mapDef Map definition.
 * @returns Number of moves.
 */
export function getPuzzleMoves(mapDef: MapDef) {
  if (shouldApplyMoveReduction()) {
    return applyMoveReduction(mapDef.moves);
  }

  // No move reduction.
  return mapDef.moves;
}

/**
 * Apply move reduction based on the original number of moves.
 * @param originalMoves Original number of moves.
 * @returns Number of moves after reduction.
 */
export function applyMoveReduction(originalMoves: number) {
  const moveReductionMap = moveReductionValues;
  const moveRanges = Object.keys(moveReductionMap)
    .map((key) => parseInt(key, 10))
    .sort((a, b) => b - a);
  const key = moveRanges.find((rangeStart) => originalMoves >= rangeStart);

  return originalMoves - (key ? moveReductionMap[key] : 0);
}
